import React, {Fragment, useContext, useRef} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {PlanContext} from "../../context/PlanContext";
import {PiPolygonLight   } from "react-icons/pi";
import {ParserDateTime} from "../../helper/dateFormatHandler";

export default function PlanInfoModal() {

    const {openPlanInfo, setOpenPlanInfo, plan} = useContext(PlanContext);
    const cancelButtonRef = useRef(null);

    return (
        <Transition.Root show={openPlanInfo} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpenPlanInfo}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-8 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6  lg:max-w-2xl">
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <PiPolygonLight  className="h-6 w-6 text-red-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h2" className="text-xl  font-bold mb-4 mt-2 leading-6 text-gray-900">
                                                Planinformationen
                                            </Dialog.Title>
                                            <div className="mt-6 flex  flex-col space-y-2">
                                                <p className="text-indego-600 font-semibold">
                                                    {plan.name}
                                                </p>
                                                <p className="text-gray-600">
                                                    Plan Id: {plan.number}
                                                </p>
                                                <p className="text-gray-600">
                                                    Art: {plan.type}
                                                </p>
                                                <p className="text-gray-600">
                                                    Erstellt: {ParserDateTime(plan?.createdAt)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-5 sm:mt-6 flex flex-row justify-around">
                                    <button
                                        type="button"
                                        className="inline-flex w-48 justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
                                        onClick={() => {
                                            window.open(window.location.origin + `/viewer/${plan.id}`,  '_blank')
                                        }}
                                    >
                                        Plan oeffnen
                                    </button>
                                    <button
                                        type="button"
                                        className="inline-flex w-48 justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-1"
                                        onClick={() => setOpenPlanInfo(false)}
                                        ref={cancelButtonRef}
                                    >
                                        Schließen
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}